import { List } from "antd-mobile/es/components/list/list";
import { useEffect, useState } from "preact/hooks";
import request from "../base/request";
import SearchBar from "./Search";
import QueryProduct from "./QueryProduct";
import Loading from "./Loading";
import { InfiniteScroll } from "antd-mobile";
import TokenModal from "./TokenModal";
import { debounce, throttle } from "lodash";

const DOMAIN = `https://secret-list.io.mlj130.com/lt/live-theme`;
const Index = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [visible, setVisible] = useState(false);
  const [token, setToken] = useState("");
  const [page, setPage] = useState(1);
  const [keywords, setKeywords] = useState('');

  useEffect(() => {
    search();
  }, [keywords, page]);

  const search = async () => {
    setLoading(true);
    const params = new URLSearchParams();
    params.set("page", page);
    if (keywords) params.set("keyword", keywords);
    const { data, err } = await request(
      DOMAIN + `/check-price?${params.toString()}`,
      { method: "GET" }
    );
    setLoading(false);
    if (err) return;
    setHasMore(data.data.hasMore);
    if (page === 1) setList(data.data.list);
    else setList([...list, ...data.data.list]);
  };

  const onClear = () => {
    setList([]);
    setKeywords('');
    setPage(1);
  };

  const loadMore = () => {
    if (loading) return;
    setLoading(true);
    setPage(page + 1);
  };

  return (
    <>
      <SearchBar onSearch={setKeywords} onClear={onClear} />
      <div style={{ height: "10px" }} />
      {loading && <Loading />}
      {list.length > 0 && (
        <List>
          {list.map((i) => (
            <List.Item>
              <QueryProduct
                {...i}
                showToken={(e) => {
                  setToken(e);
                  setVisible(true);
                }}
              />
            </List.Item>
          ))}
          <InfiniteScroll
            hasMore={hasMore}
            loadMore={throttle(loadMore, 1000)}
          />
        </List>
      )}

      <TokenModal
        token={token}
        visible={visible}
        close={() => setVisible(false)}
      />
    </>
  );
};

export default Index;
